import { render, staticRenderFns } from "./editlifeinpaxel.vue?vue&type=template&id=64434aa3&"
import script from "./editlifeinpaxel.vue?vue&type=script&lang=js&"
export * from "./editlifeinpaxel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports